import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import ChangePasswordModal from '../auth/ChangePasswordModal';

const Header = () => {
  const { currentUser, logout } = useAuth();
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);

  return (
    <header className="bg-white shadow">
      <div className="w-full" style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
        <div className="flex items-center justify-between h-16">
          {/* Left - R&D Logo */}
          <div className="flex items-center">
            <img
              src="/rd-health-tech-logo.png"
              alt="R&D HealthTech"
              className="h-10 w-auto"
            />
          </div>

          {/* Center Title */}
          <div className="flex-1 text-center">
            <h1 className="header-title">Customer Portal</h1>
          </div>

          {/* Right - User Dropdown */}
          {currentUser && (
            <div className="flex items-center">
              {/* User Dropdown */}
              <div className="relative">
                <button
                  onClick={() => setIsUserDropdownOpen(!isUserDropdownOpen)}
                  className="flex items-center text-sm font-medium text-gray-700 hover:text-gray-900 focus:outline-none"
                >
                  <span>{currentUser.name}</span>
                  <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                {isUserDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
                    <button
                      onClick={() => {
                        setIsUserDropdownOpen(false);
                        setIsChangePasswordOpen(true);
                      }}
                      className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Change Password
                    </button>
                    <hr className="my-1 border-gray-200" />
                    <button
                      onClick={() => {
                        setIsUserDropdownOpen(false);
                        logout();
                      }}
                      className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <ChangePasswordModal
        isOpen={isChangePasswordOpen}
        onClose={() => setIsChangePasswordOpen(false)}
      />
    </header>
  );
};

export default Header;
